import { AnyAction } from "redux"

export const ADD = "ADD"

export interface Add<T = any, D = any> extends AnyAction {
  resolved: typeof ADD
  type: T
  payload: D
}
